/**
 * WizCalendar utils
 * @author jzhu
 * @date 2020-06-02
 */

/**
 * 获取某月天数
 * @param {*} year 
 * @param {*} month 
 */
const monthDays = (year, month) => {
    if (!year || !month || month > 12 || month < 0) {
        return -1
    }
    let isLeapYear = year % 400 == 0 || (year % 4 == 0 && year % 100 != 0) ? true : false
    switch (month) {
        case 1:
        case 3:
        case 5:
        case 7:
        case 8:
        case 10:
        case 12:
            return 31
        case 4:
        case 6:
        case 9:
        case 11:
            return 30
        case 2:
            return isLeapYear ? 28 : 29
    }
}

/**
 * 获取上月(年月)
 * @param {*} year 
 * @param {*} month 
 */
const lastMonth = (year, month) => {
    if (!year || !month || month > 12 || month < 0) {
        return {}
    }
    if (month === 1) {
        return { year: year - 1, month: 12 }
    } else {
        return { year: year, month: month - 1 }
    }
}

/**
 * 获取下月(年月)
 * @param {*} year 
 * @param {*} month 
 */
const nextMonth = (year, month) => {
    if (!year || !month || month > 12 || month < 0) {
        return {}
    }
    if (month === 12) {
        return { year: year + 1, month: 1 }
    } else {
        return { year: year, month: month + 1 }
    }
}

/**
 * 获取某月首日周几
 * @param {*} year 
 * @param {*} month 
 */
const monthStartWeekday = (year, month) => {
    let day = new Date(year, month - 1, 1)
    return day.getDay()
}

/**
 * 获取某月最后一天周几
 * @param {*} year
 * @param {*} month 
 */
const monthEndWeekday = (year, month) => {
    let day = new Date(year, month - 1, monthDays(year, month))
    return day.getDay()
}

const equalsObjProperty = (obj = {}, source = {}) => {
    if (!Object.keys(obj).length) {
        return false
    }
    if (Object.keys(obj).length !== Object.keys(source).length) {
        return false
    }
    for (let [key, value] of Object.entries(obj)) {
        if (source[key] !== value) {
            return false
        }
    }
    return true
}

/**
 * 判断日期date是否在日期source之后
 * @param {*} source
 * @param {*} date
 */
const isAfterDate = (source = {}, date = {}) => {
    let { year, month, day } = date
    if (year > source.year) {
        return true
    } else if (year < source.year) {
        return false
    }
    if (month > source.month) {
        return true
    } else if (month < source.month) {
        return false
    }
    if (day > source.day) {
        return true
    } else if (day < source.day) {
        return false
    }
    return false
}

export default {
    monthDays,
    lastMonth,
    nextMonth,
    monthStartWeekday,
    monthEndWeekday,
    equalsObjProperty,
    isAfterDate
}